module.exports = __webpack_public_path__ + "static/media/0361_Small.8ddd31e8.jpg";